import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorFundBalanceSearch = () => {
  const fundBalanceSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/fund-balance/search', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { fundBalanceSearch }
}

export default InteractorFundBalanceSearch
